export default __webpack_public_path__ + "static/media/iluminacao.cbfb5089.png";